module.exports = __webpack_public_path__ + "img/103065.cad7ec61.png";